export const uk = {
    'avg-click-price-mandatory': 'Не указана средняя цена клика',
    'avg-cpc-ratio-weekly-budget-limit-error':
        'Увеличьте недельный бюджет. Размера недельного бюджета должно хватать для привлечения не менее {limit} конверсий.',
    'invalid-profitability': 'Процент себестоимости должен быть указан в пределах от {from} до {to}',
    'roi-coef-mandatory': 'Не указан коэффициент РОИ',
    'too-big-avg-click-price': 'Средняя цена за клик не может быть больше {limit} {currency}',
    'too-big-avg-cpa-price': 'Средняя цена конверсии не может быть больше {limit} {currency}',
    'too-big-daily-budget': 'Сумма дневного бюджета не может быть больше {limit} {currency}',
    'too-big-max-click-price': 'Максимальная цена клика должна быть меньше или равна {limit} {currency}',
    'too-big-week-bundle': 'Количество кликов в неделю должно быть не больше {limit}',
    'too-big-weekly-budget': 'Сумма недельного бюджета не может быть больше {limit} {currency}',
    'too-small-avg-click-price': 'Средняя цена за клик не может быть меньше {limit} {currency}',
    'too-small-avg-cpa-price': 'Средняя цена конверсии не может быть меньше {limit} {currency}',
    'too-small-daily-budget': 'Сумма дневного бюджета не может быть меньше {limit} {currency}',
    'too-small-max-click-price': 'Максимальная цена клика должна быть больше или равна {limit} {currency}',
    'too-small-roi-coef': 'Коэффициент рентабельности должен быть больше {limit}',
    'too-small-week-bundle': 'Количество кликов в неделю должно быть не менее {limit}',
    'too-small-weekly-budget': 'Сумма недельного бюджета не может быть меньше {limit} {currency}',
    'week-bundle-mandatory': 'Не указано количество кликов',
    'weekly-budget-mandatory': 'Не задан недельный бюджет'
};
